import { CONTAINER_TARIFF } from 'Constant';
import { createSelector } from 'reselect';
import { selectAtomicDevice } from '../Options/selectors';
import { initialState } from './reducer';

const selectTariffContainerState = (state) => state[CONTAINER_TARIFF] || initialState;

const selectSubscriptionId = () =>
    createSelector(
        selectTariffContainerState,
        state => state.subscriptionId,
    );

const selectSalesChannel = () =>
    createSelector(
        selectTariffContainerState,
        state => state.salesChannel,
    );

const selectSubscription = () =>
    createSelector(
        selectAtomicDevice(),
        device => device?.subscription || false,
    );

const selectHasSubscription = () =>
    createSelector(
        selectSubscriptionId(), selectSubscription(),
        (subscriptionId, subscription) => !!subscriptionId && !!subscription,
    );

const selectGigakombi = () =>
    createSelector(
        selectTariffContainerState, selectSubscriptionId(),
        (state, subscriptionId) => state.gigakombi && !!subscriptionId,
    );

const selectIsGigakombiEligible = () =>
    createSelector(selectTariffContainerState, state => state.gigakombi && !!state.gigakombiToken);

export {
    selectSubscriptionId,
    selectSalesChannel,
    selectSubscription,
    selectHasSubscription,
    selectGigakombi,
    selectIsGigakombiEligible,
};
